import { render, staticRenderFns } from "./GlobalComponent.vue?vue&type=template&id=10580faa&scoped=true&"
import script from "./GlobalComponent.vue?vue&type=script&lang=ts&"
export * from "./GlobalComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalComponent.vue?vue&type=style&index=0&id=10580faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10580faa",
  null
  
)

export default component.exports